// Hydrates the legacy `lineage_users` localStorage registry from the backend.
// Used by AuthContext so Rankings, Discover, BarberProfile and other surfaces
// that read from `lineage_users` automatically pick up real backend barbers
// (registrados en el backend real).
//
// Backed by GET /api/users?role=barber&order_by=ranking — public endpoint.

import { api } from '@/lib/api';

const KEY = 'lineage_users';

const _normalize = (u) => ({
  id: u.id,
  username: u.username,
  name: u.name || u.username,
  avatar: u.avatar || 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
  bio: u.bio || '',
  role: u.role,
  city: u.city,
  state: u.state,
  country: u.country,
  followers: u.followers || 0,
  following: u.following || 0,
  wins: u.wins || 0,
  losses: u.losses || 0,
  tournaments: u.tournaments || 0,
  tournamentsWon: u.tournaments_won || u.tournamentsWon || 0,
  featuredPosts: u.featured_posts || 0,
  rating: u.rating || 0,
  verified: !!u.verified,
  globalRank: u.global_rank ?? u.globalRank ?? null,
  isReal: true,
  _backendHydrated: true,
});

export const hydrateUsersFromBackend = async () => {
  try {
    const [barbers, brands] = await Promise.all([
      api.get('/users?role=barber&order_by=ranking&limit=100').catch(() => ({ items: [] })),
      api.get('/users?role=brand&limit=50').catch(() => ({ items: [] })),
    ]);
    const registry = JSON.parse(localStorage.getItem(KEY) || '{}');
    for (const u of (barbers.items || []).concat(brands.items || [])) {
      if (!u.username) continue;
      // Merge: backend wins on canonical fields; preserve any extra local fields.
      registry[u.username] = { ...(registry[u.username] || {}), ..._normalize(u) };
    }
    localStorage.setItem(KEY, JSON.stringify(registry));
    window.dispatchEvent(new Event('lineage_users_updated'));
    return Object.keys(registry).length;
  } catch {
    return 0;
  }
};
